import { render, staticRenderFns } from "./SlotActionDialog.vue?vue&type=template&id=3815af73"
import script from "./SlotActionDialog.vue?vue&type=script&lang=js"
export * from "./SlotActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports